module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "meeting-room.40860c11.svg";